import merchantConfig from '@/view/Tax/merchantConfig/index.vue'
import merchantConfigDetail from '@/view/Tax/merchantConfig/detail.vue'
import taxOrder from '@/view/Tax/order/index.vue'
import orderDetail from '@/view/Tax/order/detail.vue'
import orderCreate from '@/view/Tax/order/create.vue'
import serviceFee from '@/view/Tax/serviceFee/index.vue'
import profitShare from '@/view/Tax/profitShare/index.vue'
import merchantStat from '@/view/Tax/merchantStat/index.vue'

export default [
    {path: '/tax/merchantConfig', name: 'merchantConfig', component: merchantConfig, meta: '商户配置'},
    {path: '/tax/merchantConfigDetail', name: 'merchantConfigDetail', component: merchantConfigDetail, meta: '商户配置详情'},
    {path: '/tax/order', name: 'taxOrder', component: taxOrder, meta: '税筹订单'},
    {path: '/tax/orderDetail', name: 'orderDetail', component: orderDetail, meta: '订单详情'},
    {path: '/tax/orderCreate', name: 'orderCreate', component: orderCreate, meta: '创建订单'},
    {path: '/tax/serviceFee', name: 'serviceFee', component: serviceFee, meta: '服务费记录'},
    {path: '/tax/profitShare', name: 'profitShare', component: profitShare, meta: '分润记录'},
    {path: '/tax/merchantStat', name: 'merchantStat', component: merchantStat, meta: '商户统计'},
]